import { Component, Input } from "@angular/core";
import { AdvisorEntity } from "../../../../entities/advisor.entity";

@Component({
    selector: 'tr-advisor-about',
    templateUrl: './advisor-about.component.html',
    styleUrls: ['./advisor-about.component.scss'],
})

export class AdvisorAboutComponent {
    @Input() public advisor: AdvisorEntity;
}